import { Box, Grid } from "@mui/material"
import BreadCrumbs from "components/Breadcrumbs/Breadcrumbs"
import DrawerHeader from "components/DrawerHeader"
import { scheduledForms } from "locale/es"
import DisplayScheduledForms from "./DisplayScheduledForms";
import PendingActionsIcon from '@mui/icons-material/PendingActions';


const ScheduledFormsConfiguration = () =>
  <Box component="main" sx={{ flex: 1, p: 3, mb: 20 }}>
    <DrawerHeader />
    <BreadCrumbs name={scheduledForms.BREADCRUMBS} icon={<PendingActionsIcon sx={{ mr: 0.5 }} fontSize='inherit' />} />
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      width="100%"
    >
      <DisplayScheduledForms />
    </Grid>
  </Box>

export default ScheduledFormsConfiguration
